var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3889 9.52778C9.65556 9.52778 8.86111 9.38333 8.18889 9.09444C8.12778 9.09444 8.06667 9.09444 8.00556 9.09444C7.82222 9.09444 7.7 9.16667 7.57778 9.31111L6.23333 10.9C4.52222 9.81667 3.05556 8.15556 2.2 6.13333L3.54444 4.54444C3.72778 4.32778 3.78889 4.03889 3.66667 3.82222C3.48333 3.02778 3.36111 2.08889 3.36111 1.22222C3.36111 0.861111 3.05556 0.5 2.75 0.5H0.611111C0.305556 0.5 0 0.861111 0 1.22222C0 8.01111 4.64444 13.5 10.3889 13.5C10.6944 13.5 11 13.1389 11 12.7778V10.25C11 9.88889 10.6944 9.52778 10.3889 9.52778ZM1.22222 1.94444H2.13889C2.2 2.59444 2.32222 3.24444 2.44444 3.82222L1.71111 4.68889C1.46667 3.82222 1.28333 2.88333 1.22222 1.94444ZM9.77778 12.0556C8.98333 11.9833 8.18889 11.7667 7.45556 11.4778L8.18889 10.6111C8.67778 10.7556 9.22778 10.9 9.77778 10.9V12.0556Z",
    fill: "#343435"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.5c2d5213af73270ddd9da9ea4404b858.svg";
export { ForwardRef as ReactComponent };